import { enums } from 'edrolo-ui';

interface SelfRatingOption {
  rating: number;
  color: enums.ColorHue | enums.ColorTheme;
}
export const selfRatingOptions: SelfRatingOption[] = [
  { rating: 1, color: enums.ColorHue.RED },
  { rating: 2, color: enums.ColorHue.AMBER },
  { rating: 3, color: enums.ColorHue.YELLOW },
  { rating: 4, color: enums.ColorHue.GREEN },
  { rating: 5, color: enums.ColorTheme.FOREGROUND },
];
